import * as React from 'react';

import {Button} from 'shells/button/button';
import {GridList} from 'shells/grid-list/grid-list';
// @ts-expect-error - imported from .js/.jsx file
import {CampaignIcon} from 'shells/icon/svg/campaign-icon';
// @ts-expect-error - imported from .js/.jsx file
import {EmailIcon} from 'shells/icon/svg/email-icon';
import {FooterBar} from 'shells/modal/footer-bar';
import {OptionCard} from 'shells/option-card/option-card';
import {Body} from 'shells/typography/body';

import {createSequenceTemplate} from './create-empty-sequence-template';
import type {EmailSequenceTemplate} from './email-template-designer-modal';
import {SuggestedTemplates} from './suggested-email-sequence-templates';

import styles from './email-template-designer-create-form.module.css';

type Props = {
    onCreateNew: (sequenceTemplate: EmailSequenceTemplate, startFromScratch: boolean) => void;
};

export class EmailTemplateDesignerCreateForm extends React.Component<Props> {
    render() {
        return (
            <>
                <div className={styles['template-create-form']}>
                    <Body>
                        Nutshell can automatically follow up with your contacts. An email template
                        can contain a sequence of messages which are automatically sent if you don’t
                        get a reply. If you need some ideas, we’ve put together a few ideas to help
                        you get a reply.
                    </Body>
                    <GridList numColumns={2}>
                        {SuggestedTemplates.map((template) => (
                            <OptionCard
                                key={template.name}
                                onClick={() =>
                                    this.props.onCreateNew(template.emailSequenceTemplate, false)
                                }
                                icon={template.hasFollowups ? CampaignIcon : EmailIcon}
                                title={template.name}
                                body={template.description}
                            />
                        ))}
                    </GridList>
                </div>
                <FooterBar
                    right={
                        <Button
                            size='big'
                            variant='text-primary'
                            onClick={() => this.props.onCreateNew(createSequenceTemplate(), true)}
                        >
                            No thanks, start from scratch
                        </Button>
                    }
                />
            </>
        );
    }
}
